module.exports = __webpack_public_path__ + "img/image.d8fa59fc.png";